import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { DropdownListSettingsLanguageModel } from '@fi-shared/dropdown';
import { FiDocumentTemplateOptionsService } from '@fi-app/document-template/document-template-options.service';
import { FiDocumentTemplateLayoutTrashBinService } from '@fi-app/document-template/document-template-layout-trash-bin.service';
import { TemplateModel } from '@fi-app/template/template.model';
import { TemplateLayoutModel } from '@fi-app/template/template-layout.model';
import { IDropdownSelectLanguageSettingsItem } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

@Component({
    selector: 'fi-document-template-edit-layout',
    templateUrl: './document-template-edit-layout.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['../document-template-common.scss', './document-template-edit-layout.component.scss'],
    host: { class: 'fi-document-template-edit-layout' },
    standalone: false,
})
export class FiDocumentTemplateEditLayoutComponent implements OnInit {
    @Input('template') Template: TemplateModel;
    @Input() templateLayout: TemplateLayoutModel;
    @Input('section') ShowPage: string;

    LanguageListData: DropdownListSettingsLanguageModel<IDropdownSelectLanguageSettingsItem>;
    ShowLanguageSelector = true;
    Device = 800;

    constructor(
        public templateLayoutLanguageService: TemplateLayoutLanguageService,
        public contentLanguagesService: ContentLanguagesService,
        public documentTemplateOptionsService: FiDocumentTemplateOptionsService,
        public trashBin: FiDocumentTemplateLayoutTrashBinService,
    ) {}

    ngOnInit() {
        this.LanguageListData = this.contentLanguagesService.GetDropdownListSettingsLanguage();
        if (!this.templateLayoutLanguageService.selectedLanguage)
            this.templateLayoutLanguageService.selectedLanguage = this.LanguageListData.defaultLanguageId;
    }

    DeselectItem($event: MouseEvent) {
        this.documentTemplateOptionsService.selectedItem = undefined;
    }

    isShowModelsList() {
        return !this.documentTemplateOptionsService.selectedItem && !this.trashBin.isShow;
    }
}
